import { apiRequest } from './api';

let cachedConversations = null;
let cachedAt = 0;
let pendingRequest = null;
const messageCache = new Map();
const messageRequests = new Map();

export function getConversations({ force = false } = {}) {
  const cacheIsFresh = cachedConversations && Date.now() - cachedAt < 15000;
  if (!force && cacheIsFresh) return Promise.resolve(cachedConversations);
  if (!force && pendingRequest) return pendingRequest;

  pendingRequest = apiRequest('/conversations')
    .then((data) => {
      cachedConversations = Array.isArray(data) ? data : [];
      cachedAt = Date.now();
      return cachedConversations;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
}

export function prefetchConversations() {
  return getConversations().catch(() => null);
}

export function peekConversationMessages(conversationId) {
  return messageCache.get(conversationId)?.data || null;
}

export function getConversationMessages(conversationId, { force = false } = {}) {
  const cached = messageCache.get(conversationId);
  if (!force && cached && Date.now() - cached.at < 15000) return Promise.resolve(cached.data);
  if (!force && messageRequests.has(conversationId)) return messageRequests.get(conversationId);

  const request = apiRequest(`/conversations/${conversationId}/messages`)
    .then((data) => {
      const messages = Array.isArray(data) ? data : [];
      messageCache.set(conversationId, { data: messages, at: Date.now() });
      return messages;
    })
    .finally(() => messageRequests.delete(conversationId));
  messageRequests.set(conversationId, request);
  return request;
}

export function prefetchConversationMessages(conversations = []) {
  conversations.slice(0, 8).forEach((conversation) => {
    getConversationMessages(conversation._id).catch(() => null);
  });
}
